import type { FinalOfferReturnState } from "@/features/application/pages/ApplicationPage/ApplicationPage";
import type { ChatTurnProps } from "../../types/chat";

const isOutOfSync = (state: unknown) =>
  (state as FinalOfferReturnState | null)?.isFinalOfferOutOfSync === true;

// Nothing to answer at the end: the final offers open straight away, and
// without one the options screen does. Unless the screen sent the user back
// on facts the backend contradicted: opening it again on its own would loop.
export const getApplicationScreen = (
  props: ChatTurnProps,
  locationState: unknown,
): string | null =>
  isOutOfSync(locationState) ? null : props.step.screen.entry(props.facts);
